@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.mpay_qr_scan.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.mpay_qr_scan.generated.resources/"

internal val Res.string.feature_qr_approve_permission_description_camera: StringResource by lazy {
      StringResource("string:feature_qr_approve_permission_description_camera", "feature_qr_approve_permission_description_camera", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 148),
      ))
    }

internal val Res.string.feature_qr_camera_permission_description: StringResource by lazy {
      StringResource("string:feature_qr_camera_permission_description", "feature_qr_camera_permission_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 159, 168),
      ))
    }

internal val Res.string.feature_qr_camera_permission_title: StringResource by lazy {
      StringResource("string:feature_qr_camera_permission_title", "feature_qr_camera_permission_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 328, 74),
      ))
    }

internal val Res.string.feature_qr_close: StringResource by lazy {
      StringResource("string:feature_qr_close", "feature_qr_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 403, 32),
      ))
    }

internal val Res.string.feature_qr_dismiss: StringResource by lazy {
      StringResource("string:feature_qr_dismiss", "feature_qr_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 436, 38),
      ))
    }

internal val Res.string.feature_qr_drag_drop_hint: StringResource by lazy {
      StringResource("string:feature_qr_drag_drop_hint", "feature_qr_drag_drop_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 475, 73),
      ))
    }

internal val Res.string.feature_qr_drop_image_here: StringResource by lazy {
      StringResource("string:feature_qr_drop_image_here", "feature_qr_drop_image_here", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 549, 54),
      ))
    }

internal val Res.string.feature_qr_help: StringResource by lazy {
      StringResource("string:feature_qr_help", "feature_qr_help", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 942, 31),
      ))
    }

internal val Res.string.feature_qr_help_description: StringResource by lazy {
      StringResource("string:feature_qr_help_description", "feature_qr_help_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 604, 287),
      ))
    }

internal val Res.string.feature_qr_help_title: StringResource by lazy {
      StringResource("string:feature_qr_help_title", "feature_qr_help_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 892, 49),
      ))
    }

internal val Res.string.feature_qr_import_description: StringResource by lazy {
      StringResource("string:feature_qr_import_description", "feature_qr_import_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 974, 141),
      ))
    }

internal val Res.string.feature_qr_import_qr_code: StringResource by lazy {
      StringResource("string:feature_qr_import_qr_code", "feature_qr_import_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1116, 53),
      ))
    }

internal val Res.string.feature_qr_instruction: StringResource by lazy {
      StringResource("string:feature_qr_instruction", "feature_qr_instruction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1170, 130),
      ))
    }

internal val Res.string.feature_qr_loading: StringResource by lazy {
      StringResource("string:feature_qr_loading", "feature_qr_loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1301, 38),
      ))
    }

internal val Res.string.feature_qr_no_qr_found: StringResource by lazy {
      StringResource("string:feature_qr_no_qr_found", "feature_qr_no_qr_found", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1340, 82),
      ))
    }

internal val Res.string.feature_qr_ok: StringResource by lazy {
      StringResource("string:feature_qr_ok", "feature_qr_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1423, 25),
      ))
    }

internal val Res.string.feature_qr_oops: StringResource by lazy {
      StringResource("string:feature_qr_oops", "feature_qr_oops", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1449, 31),
      ))
    }

internal val Res.string.feature_qr_open_settings: StringResource by lazy {
      StringResource("string:feature_qr_open_settings", "feature_qr_open_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1481, 52),
      ))
    }

internal val Res.string.feature_qr_permission_required: StringResource by lazy {
      StringResource("string:feature_qr_permission_required", "feature_qr_permission_required", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1534, 66),
      ))
    }

internal val Res.string.feature_qr_powered_by: StringResource by lazy {
      StringResource("string:feature_qr_powered_by", "feature_qr_powered_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1601, 53),
      ))
    }

internal val Res.string.feature_qr_preview_image: StringResource by lazy {
      StringResource("string:feature_qr_preview_image", "feature_qr_preview_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1655, 68),
      ))
    }

internal val Res.string.feature_qr_proceed: StringResource by lazy {
      StringResource("string:feature_qr_proceed", "feature_qr_proceed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1724, 38),
      ))
    }

internal val Res.string.feature_qr_processing: StringResource by lazy {
      StringResource("string:feature_qr_processing", "feature_qr_processing", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1763, 57),
      ))
    }

internal val Res.string.feature_qr_scan_any_qr: StringResource by lazy {
      StringResource("string:feature_qr_scan_any_qr", "feature_qr_scan_any_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1821, 46),
      ))
    }

internal val Res.string.feature_qr_scan_code: StringResource by lazy {
      StringResource("string:feature_qr_scan_code", "feature_qr_scan_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1868, 40),
      ))
    }

internal val Res.string.feature_qr_scan_qr_code: StringResource by lazy {
      StringResource("string:feature_qr_scan_qr_code", "feature_qr_scan_qr_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1909, 47),
      ))
    }

internal val Res.string.feature_qr_scan_success: StringResource by lazy {
      StringResource("string:feature_qr_scan_success", "feature_qr_scan_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1957, 71),
      ))
    }

internal val Res.string.feature_qr_scan_valid_qr: StringResource by lazy {
      StringResource("string:feature_qr_scan_valid_qr", "feature_qr_scan_valid_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2029, 60),
      ))
    }

internal val Res.string.feature_qr_select_image: StringResource by lazy {
      StringResource("string:feature_qr_select_image", "feature_qr_select_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2090, 47),
      ))
    }

internal val Res.string.feature_qr_select_qr_image: StringResource by lazy {
      StringResource("string:feature_qr_select_qr_image", "feature_qr_select_qr_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2138, 62),
      ))
    }

internal val Res.string.feature_qr_supported_formats: StringResource by lazy {
      StringResource("string:feature_qr_supported_formats", "feature_qr_supported_formats", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2201, 80),
      ))
    }

internal val Res.string.feature_qr_supported_transfers: StringResource by lazy {
      StringResource("string:feature_qr_supported_transfers", "feature_qr_supported_transfers", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2282, 74),
      ))
    }

internal val Res.string.feature_qr_toggle_flash: StringResource by lazy {
      StringResource("string:feature_qr_toggle_flash", "feature_qr_toggle_flash", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2357, 55),
      ))
    }

internal val Res.string.feature_qr_torch: StringResource by lazy {
      StringResource("string:feature_qr_torch", "feature_qr_torch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2413, 32),
      ))
    }

internal val Res.string.feature_qr_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_qr_unexpected_error_subtitle", "feature_qr_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2446, 108),
      ))
    }

internal val Res.string.feature_qr_upload_qr: StringResource by lazy {
      StringResource("string:feature_qr_upload_qr", "feature_qr_upload_qr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2555, 40),
      ))
    }

internal val Res.string.feature_qr_viewfinder: StringResource by lazy {
      StringResource("string:feature_qr_viewfinder", "feature_qr_viewfinder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2596, 53),
      ))
    }

internal val Res.string.feature_qr_warning_message: StringResource by lazy {
      StringResource("string:feature_qr_warning_message", "feature_qr_warning_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2650, 358),
      ))
    }

internal val Res.string.feature_qr_warning_title: StringResource by lazy {
      StringResource("string:feature_qr_warning_title", "feature_qr_warning_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3009, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_qr_approve_permission_description_camera", Res.string.feature_qr_approve_permission_description_camera)
  map.put("feature_qr_camera_permission_description", Res.string.feature_qr_camera_permission_description)
  map.put("feature_qr_camera_permission_title", Res.string.feature_qr_camera_permission_title)
  map.put("feature_qr_close", Res.string.feature_qr_close)
  map.put("feature_qr_dismiss", Res.string.feature_qr_dismiss)
  map.put("feature_qr_drag_drop_hint", Res.string.feature_qr_drag_drop_hint)
  map.put("feature_qr_drop_image_here", Res.string.feature_qr_drop_image_here)
  map.put("feature_qr_help", Res.string.feature_qr_help)
  map.put("feature_qr_help_description", Res.string.feature_qr_help_description)
  map.put("feature_qr_help_title", Res.string.feature_qr_help_title)
  map.put("feature_qr_import_description", Res.string.feature_qr_import_description)
  map.put("feature_qr_import_qr_code", Res.string.feature_qr_import_qr_code)
  map.put("feature_qr_instruction", Res.string.feature_qr_instruction)
  map.put("feature_qr_loading", Res.string.feature_qr_loading)
  map.put("feature_qr_no_qr_found", Res.string.feature_qr_no_qr_found)
  map.put("feature_qr_ok", Res.string.feature_qr_ok)
  map.put("feature_qr_oops", Res.string.feature_qr_oops)
  map.put("feature_qr_open_settings", Res.string.feature_qr_open_settings)
  map.put("feature_qr_permission_required", Res.string.feature_qr_permission_required)
  map.put("feature_qr_powered_by", Res.string.feature_qr_powered_by)
  map.put("feature_qr_preview_image", Res.string.feature_qr_preview_image)
  map.put("feature_qr_proceed", Res.string.feature_qr_proceed)
  map.put("feature_qr_processing", Res.string.feature_qr_processing)
  map.put("feature_qr_scan_any_qr", Res.string.feature_qr_scan_any_qr)
  map.put("feature_qr_scan_code", Res.string.feature_qr_scan_code)
  map.put("feature_qr_scan_qr_code", Res.string.feature_qr_scan_qr_code)
  map.put("feature_qr_scan_success", Res.string.feature_qr_scan_success)
  map.put("feature_qr_scan_valid_qr", Res.string.feature_qr_scan_valid_qr)
  map.put("feature_qr_select_image", Res.string.feature_qr_select_image)
  map.put("feature_qr_select_qr_image", Res.string.feature_qr_select_qr_image)
  map.put("feature_qr_supported_formats", Res.string.feature_qr_supported_formats)
  map.put("feature_qr_supported_transfers", Res.string.feature_qr_supported_transfers)
  map.put("feature_qr_toggle_flash", Res.string.feature_qr_toggle_flash)
  map.put("feature_qr_torch", Res.string.feature_qr_torch)
  map.put("feature_qr_unexpected_error_subtitle", Res.string.feature_qr_unexpected_error_subtitle)
  map.put("feature_qr_upload_qr", Res.string.feature_qr_upload_qr)
  map.put("feature_qr_viewfinder", Res.string.feature_qr_viewfinder)
  map.put("feature_qr_warning_message", Res.string.feature_qr_warning_message)
  map.put("feature_qr_warning_title", Res.string.feature_qr_warning_title)
}
